import { useContext } from "react";
import { DashboardTranslationLocaleContext } from "../dashboard-translation-locale"
import DashboardTranslationStore from "../stores/dashboard-translations-store";

function useDashboardTranslation(): typeof DashboardTranslationStore {
    const context: typeof DashboardTranslationStore = useContext(DashboardTranslationLocaleContext);

    /** check if the component is inside <DashboardTranslationLocale ...> component */
    if (!context?.getTranslation) {
        throw new Error('Missing DashboardTranslationLocale component above DashboardTranslation component/hook');
    }

    return context;
}

export default useDashboardTranslation; 
